// extracted by mini-css-extract-plugin
module.exports = {"modal":"RWBModal_modal__2p0Wp","paper":"RWBModal_paper__1tL_E","xIconContainer":"RWBModal_xIconContainer__1xy3g"};